import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,

  farmlist: [],
  testHistory: [],
  detailTest: [],
  statisticFarm: [],
  detailResultList: [],
  assessmentList: [],
  frequencyList: [],
  assessmentStatistic: [],
  filterStatisticFarm: {
    year: new Date().getFullYear(),
    province: "",
    region: "",
  },
  filterDetailResult: {
    fromDate: "",
    toDate: "",
    province: "",
    region: "",
    name: "",
    hinhThucTiepCan: null,
    hinhThucKiemTra: null,
    farmIds: null,
  },
  filterAssessment: {
    year: new Date().getFullYear(),
    province: "",
    region: "",
  },
  filterFrequency: {
    year: new Date().getFullYear(),
    province: "",
    region: "",
  },
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    // FarmList
    fetchFarmList: (state) => {
      state.loading = true;
    },
    fetchFarmListSuccess: (state, action) => {
      state.loading = false;
      state.farmlist = action.payload;
    },
    fetchFarmListFailed: (state) => {
      state.loading = false;
    },

    // Test History
    fetchTestHistory: (state) => {
      state.loading = true;
    },
    fetchTestHistorySuccess: (state, action) => {
      state.loading = false;
      state.testHistory = action.payload;
    },
    fetchTestHistoryFailed: (state) => {
      state.loading = false;
    },

    //  Detail Test

    fetchDetailTest: (state) => {
      state.loading = true;
    },
    fetchDetailTestSuccess: (state, action) => {
      state.loading = false;
      state.detailTest = action.payload;
    },
    fetchDetailTestFailed: (state) => {
      state.loading = false;
    },

    //  Statistic Farm

    fetchStatisticFarms: (state) => {
      state.loading = true;
    },
    fetchStatisticFarmsSuccess: (state, action) => {
      state.loading = false;
      state.statisticFarm = action.payload;
    },
    fetchStatisticFarmsFailed: (state) => {
      state.loading = false;
    },

    setFilterStatisticFarm: (state, action) => {
      state.filterStatisticFarm = action.payload;
    },

    // Detail Result
    fetchDetailResult: (state) => {
      state.loading = true;
    },
    fetchDetailResultSuccess: (state, action) => {
      state.loading = false;
      state.detailResultList = action.payload;
    },
    fetchDetailResultFailed: (state) => {
      state.loading = false;
    },
    setFilterDetailResult: (state, action) => {
      state.filterDetailResult = action.payload;
    },

    // Assessment

    fetchListAssessment: (state) => {
      state.loading = true;
    },
    fetchListAssessmentSuccess: (state, action) => {
      state.loading = false;
      state.assessmentList = action.payload;
    },
    fetchListAssessmentFailed: (state) => {
      state.loading = false;
    },

    fetchListStatisticAssessment: (state) => {
      state.loading = true;
    },
    fetchListStatisticAssessmentSuccess: (state, action) => {
      state.loading = false;
      state.assessmentStatistic = action.payload;
    },
    fetchListStatisticAssessmentFailed: (state) => {
      state.loading = false;
    },

    setFilterAssessment: (state, action) => {
      state.filterAssessment = action.payload;
    },

    //  Frequency

    fetchFrequencyList: (state) => {
      state.loading = true;
    },
    fetchFrequencyListSuccess: (state, action) => {
      state.loading = false;
      state.frequencyList = action.payload;
    },
    fetchFrequencyListFailed: (state) => {
      state.loading = false;
    },

    setFilterFrequency: (state, action) => {
      state.filterFrequency = action.payload;
    },
  },
});

// actions
export const {
  fetchFarmList,
  fetchFarmListSuccess,
  fetchFarmListFailed,

  fetchTestHistory,
  fetchTestHistorySuccess,
  fetchTestHistoryFailed,

  fetchDetailTest,
  fetchDetailTestSuccess,
  fetchDetailTestFailed,

  fetchStatisticFarms,
  fetchStatisticFarmsSuccess,
  fetchStatisticFarmsFailed,
  setFilterStatisticFarm,

  fetchFrequencyList,
  fetchFrequencyListSuccess,
  fetchFrequencyListFailed,
  setFilterFrequency,

  fetchDetailResult,
  fetchDetailResultSuccess,
  fetchDetailResultFailed,
  setFilterDetailResult,

  setFilterAssessment,
  fetchListAssessment,
  fetchListAssessmentSuccess,
  fetchListAssessmentFailed,
  fetchListStatisticAssessment,
  fetchListStatisticAssessmentSuccess,
  fetchListStatisticAssessmentFailed,
} = adminSlice.actions;
// selector
export const selectLoading = (state) => state.adminReducer.loading;

export const selectFarmList = (state) => state.adminReducer.farmlist;

export const selectFrequencyList = (state) => state.adminReducer.frequencyList;

export const selectTestHistory = (state) => state.adminReducer.testHistory;

export const selectDetailTest = (state) => state.adminReducer.detailTest;

export const selectAssessmentList = (state) =>
  state.adminReducer.assessmentList;
export const selectDetailResultList = (state) =>
  state.adminReducer.detailResultList;
export const selectStatisticAssessmentList = (state) =>
  state.adminReducer.assessmentStatistic;

export const selectStatisticFarm = (state) => state.adminReducer.statisticFarm;
export const selectFilterStatisticFarm = (state) =>
  state.adminReducer.filterStatisticFarm;
export const selectFilterDetailResult = (state) =>
  state.adminReducer.filterDetailResult;
  export const selectFilterFrequency = (state) =>
  state.adminReducer.filterFrequency;
export const selectFilterAssessment = (state) =>
  state.adminReducer.filterAssessment;
// reducer

const adminReducer = adminSlice.reducer;
export default adminReducer;
